<!--<ion-header>-->
<!--  <ion-toolbar>-->
<!--    <ion-title>-->
<!--      Account-->
<!--    </ion-title>-->
<!--  </ion-toolbar>-->
<!--</ion-header>-->

<ion-content>
  <ion-list>

    <ion-item>{{ auth.user?.email }}</ion-item>
    <ion-item (click)="audio.toggleAudio()">
      <ng-container *ngIf="audio.enabled">
        <ion-icon
          slot="start"
          name="volume-high-outline">
        </ion-icon>
        Sound aktivieren
      </ng-container>
      <ng-container *ngIf="!audio.enabled">
        <ion-icon slot="start"
                  name="volume-mute-outline">
        </ion-icon>
        Stumm schalten
      </ng-container>
    </ion-item>
    <ion-item (click)="logout()">Abmelden</ion-item>
  </ion-list>
</ion-content>
